module.exports = __webpack_public_path__ + "assets/img/img12.d1350fee.png";